import axios from 'axios'
import config from '@/config'
/** getEligibility request check if widget should show or not for specific pages
 * @returns {Promise<AxiosResponse<any>>}
 */

let DOMAIN = config.DOMAIN
let EligibilityUrl = DOMAIN + config.API_ELIGIBILITY
let agentInformationUrl = DOMAIN + config.API_MEDALIA_AVALABILIT
let agentAvailabilityUrl = DOMAIN + config.API_AGENT_AVAILABILITY 

export function getEligibility (params) {
  const requestParam = window.location.pathname + window.location.search + window.location.hash
  return axios
    .get(EligibilityUrl, {
      params: {
        url: requestParam,
        ...params
      },
       withCredentials: true
    })
}

export function getAgentAvailability (params) {
  return axios.get(agentAvailabilityUrl, {
    params: {
      ...params
    }
    // withCredentials: true
  })
}
// 1. Get the agent information from Redis cache by chatSessionId or uniqueChatId
export function getAgentInformation (id) {
  const url = `${agentInformationUrl}/${id}`
  return axios
    .get(url, {}, {
      params: {
        url: url
      }
      // withCredentials: true
    })
}